/**
 * Cart page: show outfit photo as thumbnail and estimated price as displayed line price/total.
 * Re-runs after quantity change (cart-update) so price stays correct.
 */
(function() {
  'use strict';
  if (!window.location.pathname.match(/^\/cart$/)) return;

  function parseEstimatedAmount(str) {
    if (!str || typeof str !== 'string') return 0;
    var n = str.replace(/[^\d.]/g, '');
    return parseFloat(n) || 0;
  }

  function applyOutfitCartUpdates() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart.items || !cart.items.length) return;
        var rows = document.querySelectorAll('tr.cart-item[data-key]');
        var totalFromEstimates = 0;
        var hasOutfitItems = false;
        cart.items.forEach(function(item, index) {
          var props = item.properties || {};
          var outfitPhoto = props['Outfit Photo'];
          var estimatedPrice = props['Estimated Price'];
          var estimatedAmountNum = props['_estimated_price'] != null ? parseFloat(props['_estimated_price']) : NaN;
          if (isNaN(estimatedAmountNum)) estimatedAmountNum = parseEstimatedAmount(estimatedPrice);
          var row = document.querySelector('tr.cart-item[data-key="' + item.key + '"]');
          if (!row && rows[index]) row = rows[index];
          if (!row) return;

          if (outfitPhoto && (outfitPhoto.indexOf('data:image') === 0 || outfitPhoto.indexOf('https://') === 0)) {
            var img = row.querySelector('.cart-item__image-container img, .cart-item__media img, img.cart-item__image');
            if (!img) img = row.querySelector('img');
            if (img) {
              img.src = outfitPhoto;
              img.alt = img.alt || 'Outfit reference';
              img.style.objectFit = 'cover';
            }
          }

          if (estimatedPrice || !isNaN(estimatedAmountNum)) {
            hasOutfitItems = true;
            var amount = !isNaN(estimatedAmountNum) ? estimatedAmountNum : parseEstimatedAmount(estimatedPrice);
            if (amount > 0) totalFromEstimates += amount * (item.quantity || 1);
            var displayPrice = estimatedPrice || (amount > 0 ? '₹' + amount.toLocaleString('en-IN') : '');
            var lineTotalDisplay = item.quantity > 1 ? amount * item.quantity : amount;
            var lineTotalStr = lineTotalDisplay > 0 ? '₹' + lineTotalDisplay.toLocaleString('en-IN') : displayPrice;
            row.querySelectorAll('[data-hulkapps-line-price], [data-hulkapps-ci-price], .cart-item__totals .price, .cart-item__price-wrapper .price, .cart-item__details .price').forEach(function(el) {
              if (el.closest('.cart-item__totals') || el.hasAttribute('data-hulkapps-line-price')) {
                el.textContent = lineTotalStr;
              } else {
                el.textContent = displayPrice;
              }
              el.classList.add('outfit-cart-replaced');
            });
            row.querySelectorAll('.outfit-cart-estimated-price').forEach(function(el) { el.remove(); });
            var priceCell = row.querySelector('.cart-item__price-wrapper');
            if (priceCell) {
              var estEl = document.createElement('div');
              estEl.className = 'outfit-cart-estimated-price';
              estEl.style.marginTop = '4px';
              estEl.style.fontWeight = '600';
              estEl.textContent = lineTotalStr;
              priceCell.appendChild(estEl);
            }
          }

          if (outfitPhoto && outfitPhoto.length > 500) {
            row.querySelectorAll('.product-option').forEach(function(el) {
              var text = (el.textContent || '').trim();
              if (text.indexOf('Outfit Photo') === 0 || text.indexOf('data:image') === 0) {
                el.style.display = 'none';
              }
            });
          }
        });

        if (hasOutfitItems && totalFromEstimates > 0) {
          var totalEl = document.querySelector('.cart__ctas .cart__total .price, .totals__total .price, [class*="cart__total"] .price, .totals__total-value');
          if (totalEl) {
            totalEl.textContent = '₹' + totalFromEstimates.toLocaleString('en-IN');
            totalEl.classList.add('outfit-cart-replaced');
          }
        }
      })
      .catch(function() {});
  }

  function runAfterCartUpdate() {
    applyOutfitCartUpdates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAfterCartUpdate);
  } else {
    runAfterCartUpdate();
  }
  document.addEventListener('cart:refresh', runAfterCartUpdate);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, runAfterCartUpdate);
  }
  var observerTarget = document.getElementById('main-cart-items');
  if (observerTarget && typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(function() { setTimeout(runAfterCartUpdate, 100); });
    mo.observe(observerTarget, { childList: true, subtree: true });
  }
})();
